import React from 'react';
import {connect} from "react-redux";
import { withTranslation } from 'react-i18next';
import Button from "../../../../../../../../components/button";
import {
    selectedContacts,
} from "../../../../../../../../../actions/contactActions";
import {getSharingDetailsPopup} from "../../../../../../../../../actions/sharingDetailsActions";
import BulkContactsActions from './components/bulk-contacts-actions';
import './index.css';

class ListOfContactsBodyHead extends React.Component {

	constructor(props){
		super(props);

        this.clickHandler = this.clickHandler.bind(this);
        this.handleAddNewContact = this.handleAddNewContact.bind(this);
	}

    handleAddNewContact(){
       this.props.getSharingDetailsPopup([true, 'gmail_new_contact'])

    }

    clickHandler(e){

        let cTarget = e.currentTarget;

        if(cTarget.checked){

            let allTheContacts = null;

            if(this.props.contactSearchResult && this.props.contactSearchResult.contacts.length > 0){
                allTheContacts = this.props.contactSearchResult.contacts.map(item => {
                    return {
                        'id': item.id,
                        'type': item.type ? item.type : 'contact',
                        'shareable': item.shareable ? 'true': 'false',
                    }
                });
            } else {
                allTheContacts = this.props.findContacts.contacts.filter(function(item){

                    if(item.editable === true || item.deletable === true || item.shareable === true){
                        return  {
                            'id': item.id,
                            'type': item.type ? item.type : 'contact',
                            'shareable': item.shareable ? 'true': 'false',
                        }
                    } else {
                        return null;
                    }

                })
            }

            if(this.props.selectedContacts.length > 0){

                let ids = new Set(this.props.selectedContacts.map(itemSelected => itemSelected.id));

                this.props.setSelectedContacts([
                    ...this.props.selectedContacts,
                    ...allTheContacts.filter(itemContact => !ids.has(itemContact.id))
                ]);

            } else {

                this.props.setSelectedContacts([
                    ...this.props.selectedContacts,
                    ...allTheContacts
                ]);

            }

            document.querySelectorAll(".contact .custom-control-input").forEach(item => {
                item.checked = !(item.dataset.shareable === 'false' && item.dataset.editable === 'false');
            });
        }
        else {
            document.querySelectorAll(".contact .custom-control-input").forEach(item => {
                item.checked = false
            });

            this.props.setSelectedContacts([]);
		}

	}

    render() {
        return (
            <div className="list-of-contacts-columns d-flex border-bottom align-items-center pl-3 pr-2">
                {this.props.checkGmailAddOnData?.action==='addToAContact'?
               <div>
                    <Button className="btn-primary ml-2" onClick={this.handleAddNewContact}>
                       {this.props.t("textCreateContact")}
                    </Button>
               </div>:<div className="d-flex align-items-center">
                    <div className="custom-control custom-checkbox my-1 mr-sm-2">
                        <input
                            onClick={this.clickHandler}
                            type="checkbox"
                            className="custom-control-input"
                            id="massContactsSelection"
                            disabled={
                                !this.props.selectedContactsGroup || this.props.selectedContactsGroup.permission === 'READ_ONLY'
                                || this.props.selectedContactsGroup.directorySyncType === 'DIRECTORY_LED'
                            }
                        />
                        <label className="custom-control-label" htmlFor="massContactsSelection"/>
                    </div>
                    <span className="text-nowrap">{this.props.t("headerSelectAllText")}</span>
                </div>
                }
                <div className="text-center mx-auto px-3">
                    {/*<ContactsListAlphabeticalPagination/>*/}
                </div>
                <div className="text-right">
	                {/*<ContactsListPagination/>*/}
                </div>
	            {this.props.checkGmailAddOnData?.action === 'addToAContact' ? '' : <BulkContactsActions/>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        findContacts: state.contactReducer.findContacts,
        contactSearchResult: state.contactReducer.contactSearchResult,
        selectedContacts: state.contactReducer.selectedContacts,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        checkGmailAddOnData:state.profileReducer.setGmailAddOnData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedContacts : (array) => {
            dispatch(selectedContacts(array))
        },
        getSharingDetailsPopup: (array) => {
            dispatch(getSharingDetailsPopup(array))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListOfContactsBodyHead));
